import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 8480FB3F-93B8-4445-BE6D-56A47441D6A6
 * name format-list-numbered-rtl
 * version: 3.3.92
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/format-list-numbered-rtl.svg
 * tags
 * - Text / Content / Format 
 */
export const FormatListNumberedRtlIcon = createSvgIcon(<><path d="M3,13V11H17V13H3M3,19V17H17V19H3M3,7V5H17V7H3M20,8V5H19V4H21V8H20M19,17V16H22V20H19V19H21V18.5H20V17.5H21V17H19M21.25,10C21.67,10 22,10.34 22,10.75C22,10.95 21.92,11.14 21.79,11.27L20.12,13H22V14H19V13.08L21,11H19V10H21.25Z" /></>, 'FormatListNumberedRtlIcon');
export default FormatListNumberedRtlIcon